export const ROOT_MENU_ITEM_ID = "profile";
export const RECENT_ACTIVITY_PATH = "recent_activity";
